import { render, staticRenderFns } from "./Pflibrary.vue?vue&type=template&id=15a4abb9&scoped=true"
import script from "./Pflibrary.vue?vue&type=script&lang=js"
export * from "./Pflibrary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a4abb9",
  null
  
)

export default component.exports